module.exports = __webpack_public_path__ + "static/img/g3.6d27865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/g3.png
// module id = DIby
// module chunks = 1